// PHA-1168: lets other screens (the Reports page) put text into the Ask Phanova
// input. The chat may not be mounted yet (it mounts when the panel opens), so a
// request is parked here until the input mounts and takes it; an input that is
// already mounted hears the event.
export const CHAT_PREFILL_EVENT = 'phanova:prefill-chat-input';

let pendingPrefill: string | null = null;

export function requestChatPrefill(text: string): void {
  pendingPrefill = text;
  window.dispatchEvent(new CustomEvent<string>(CHAT_PREFILL_EVENT, { detail: text }));
}

/** Returns the parked prefill once, then clears it. */
export function consumeChatPrefill(): string | null {
  const text = pendingPrefill;
  pendingPrefill = null;
  return text;
}
